<template>
  <div>
    <a-card title="追溯产品管理">
      <a-row :gutter="16">
        <a-col :span="24" style="max-width: 200px; margin-bottom: 12px">
          <a-input v-model="searchForm.product_kw" placeholder="id或名称" allowClear @pressEnter="search" />
        </a-col>
        <a-col :span="24" style="width: 100px; margin-bottom: 12px">
          <a-button type="primary" icon="search" @click="search">查询</a-button>
        </a-col>

        <div style="margin-bottom: 12px; float: right">
          <a-button type="primary" icon="vertical-align-bottom" @click="onUpload()">下载</a-button>
          <a-button type="primary" icon="plus" style="margin: 0 8px" @click="openFormModal(form, false)">新增产品</a-button>
        </div>
      </a-row>

      <a-row style="margin-top: 12px">
        <a-table size="small" :row-selection="{ selectedRowKeys: selectedKeys, onChange: onSelectChange }"
          :columns="columns" :pagination="pagination" :dataSource="items" rowKey="id" :loading="loading"
          @change="tableChange" :scroll="{ x: '100%' }">
          <div slot="shelf_life_days" slot-scope="text, item">
            <span>{{ (goodsInfoMap[item.product_id] && goodsInfoMap[item.product_id].shelf_life_days) || (item.goods && item.goods.shelf_life_days) || '' }}{{ (goodsInfoMap[item.product_id] && goodsInfoMap[item.product_id].period_unit) || (item.goods && item.goods.period_unit) || '' }}</span>
          </div>
          <div slot="product_id" slot-scope="text, item">
            <a-tooltip placement="topLeft" :title="goodsInfoMap[item.product_id] ? goodsInfoMap[item.product_id].id : text">
              <span>{{ goodsInfoMap[item.product_id] ? goodsInfoMap[item.product_id].id : text }}</span>
            </a-tooltip>
          </div>
          <div slot="product_name" slot-scope="text, item">
            <a-tooltip placement="topLeft" :title="goodsMap[item.product_id] || text">
              <span>{{ goodsMap[item.product_id] || text }}</span>
            </a-tooltip>
          </div>
          <div slot="action" slot-scope="value, item">
            <a-button-group>
              <a-button icon="vertical-align-bottom" size="small" @click="onUpload(item)">下载</a-button>
              <a-button icon="eye" size="small" @click="openFormModal1(item)">查看</a-button>
              <a-button icon="edit" size="small" @click="openFormModal(item, item.goods && item.goods.types === 'material')">编辑</a-button>
              <a-popconfirm title="确定删除吗" @confirm="destroy(item.id)">
                <a-button type="danger" icon="delete" size="small">删除</a-button>
              </a-popconfirm>
            </a-button-group>
          </div>
        </a-table>
      </a-row>
    </a-card>
    <form-modal v-if="visible" v-model="visible" :oform="targetItem"
      :clientsClassificationOptions="clientsClassificationItems" 
      :isRawMaterial="isRawMaterial"
      @create="create" @update="update" />
    <form-modal1 v-model="visible1" :form="targetItem1" :clientsClassificationOptions="clientsClassificationItems1" />
    <a-modal v-model="importLoading" :footer="null" :maskClosable="false" :closable="false">
      <div><a-spin style="margin-right: 12px" />正在导入中, 请等待...</div>
    </a-modal>
  </div>
</template>

<script>
import { fromProductList, fromProductDel, generateQR } from "@/api/from";
import { goodsInformationList } from "@/api/goods";
export default {
  name: "Warehouse",
  components: {
    FormModal: () => import("./FormModal.vue"),
    FormModal1: () => import("./FormModal1.vue")
  },
  data() {
    return {
      pagination: { current: 1, total: 0, pageSize: 20, showSizeChanger: true, pageSizeOptions: ['20', '50', '100', '200', '500'] },
      selectedKeys: [],
      goodsMap: {}, // 缓存产品信息，用于实时获取最新产品名称
      goodsInfoMap: {}, // 缓存产品完整信息，用于同步id等字段
      columns: [
        {
          title: "id",
          dataIndex: "product_id",
          width: "60px",
          scopedSlots: { customRender: "product_id" }
        },
        {
          title: "产品名称",
          dataIndex: "product_name",
          ellipsis: true,
          width: "120px",
          scopedSlots: { customRender: "product_name" }
        },
        /* {
          title: "状态",
          scopedSlots: { customRender: "status" },
          dataIndex: "status"
        }, */
        {
          title: "品牌",
          dataIndex: "product_brand",
          ellipsis: true,
          width: "100px",
          customRender: (text, item) => {
            const g = this.goodsInfoMap[item.product_id] || {};
            const val = g.product_brand || text;
            return <a-tooltip placement="topLeft" title={val}><span>{val}</span></a-tooltip>;
          }
        },
        {
          title: "销售区域",
          dataIndex: "sales_area",
          ellipsis: true,
          width: "100px",
          customRender: (text, item) => {
            const g = this.goodsInfoMap[item.product_id] || {};
            const val = g.sales_area || text;
            return <a-tooltip placement="topLeft" title={val}><span>{val}</span></a-tooltip>;
          }
        },
        {
          title: "产品类型",
          dataIndex: "category",
          width: "100px",
          customRender: (text, item) => {
            const g = this.goodsInfoMap[item.product_id] || {};
            const val = g.category_name || (g.category && g.category.name) || text;
            return val;
          }
        },
        {
          title: "联系方式",
          dataIndex: "remark",
          width: "100px",
        },
        {
          title: "产品规格",
          dataIndex: "spec",
          width: "100px",
          customRender: (text, item) => {
            const g = this.goodsInfoMap[item.product_id] || {};
            return g.spec || text;
          }
        },
        {
          title: "执行标准",
          dataIndex: "standards",
          width: "100px",
          customRender: (text, item) => {
            const g = this.goodsInfoMap[item.product_id] || {};
            return g.standards || text;
          }
        },
        {
          title: "净含量",
          dataIndex: "net_content",
          width: "80px",
          customRender: (text, item) => {
            const g = this.goodsInfoMap[item.product_id] || {};
            return g.net_content || text;
          }
        },
        {
          title: "保质期",
          scopedSlots: { customRender: "shelf_life_days" },
          width: "80px"
        },
        {
          title: "生产企业",
          dataIndex: "commpany",
          ellipsis: true,
          width: "100px",
          customRender: (text, item) => {
            const g = this.goodsInfoMap[item.product_id] || {};
            const val = g.commpany || text;
            return <a-tooltip placement="topLeft" title={val}><span>{val}</span></a-tooltip>;
          }
        },
        {
          title: "生产企业地址",
          dataIndex: "adreess",
          ellipsis: true,
          width: "150px",
          customRender: (text, item) => {
            const g = this.goodsInfoMap[item.product_id] || {};
            const val = g.adreess || text;
            return <a-tooltip placement="topLeft" title={val}><span>{val}</span></a-tooltip>;
          }
        },
        {
          title: "操作",
          dataIndex: "action",
          scopedSlots: { customRender: "action" },
          width: "275px",
          fixed: "right"
        },
      ],
      searchForm: { product_kw: "", page: 1, page_size: 20 },
      loading: false,
      items: [],
      clientsClassificationItems: [],
      clientsClassificationItems1: [],
      visible: false,
      visible1: false,
      targetItem: {},
      targetItem1: {},
      form: {},
      importLoading: false,
      isRawMaterial: false, // 是否为原料类型
    };
  },
  methods: {
    onSelectChange(selectedRowKeys) {
      console.log('selectedRowKeys changed: ', selectedRowKeys);
      this.selectedKeys = selectedRowKeys;
    },
    async onUpload(record) {
      const handleQRRes = (res) => {
        if (typeof res.data === 'string') {
          // Python 格式：返回静态文件 URL，fetch 转 blob 触发下载
          const url = res.data;
          const filename = decodeURIComponent(url.split('/').pop());
          fetch(url)
            .then(r => r.blob())
            .then(blob => {
              const blobUrl = URL.createObjectURL(blob);
              const a = document.createElement('a');
              a.href = blobUrl;
              a.download = filename;
              document.body.appendChild(a);
              a.click();
              document.body.removeChild(a);
              URL.revokeObjectURL(blobUrl);
            })
            .catch(() => window.open(url, '_blank'));
        } else if (res.data && res.data.data) {
          // Go 格式：返回 base64
          const a = document.createElement('a');
          a.href = res.data.data;
          a.download = res.data.filename || 'qrcode.png';
          document.body.appendChild(a);
          a.click();
          document.body.removeChild(a);
        }
      };
      /**单个下载 */
      if (record) {
        const res = await generateQR({ id: record.id });
        handleQRRes(res);
        return;
      }
      if (this.selectedKeys.length > 0) {
        if (this.selectedKeys.length === 1) {
          const res = await generateQR({ id: this.selectedKeys[0] });
          handleQRRes(res);
          return;
        } else {
          /**多个 */
          const res = await generateQR({ product_id: this.selectedKeys });
          handleQRRes(res);
          return;
        }
      } else {
        this.$message.warn('请勾选！');
      }
    },
    initialize() {
      this.list();
    },
    list() {
      this.loading = true;
      fromProductList(this.searchForm)
        .then((data) => {
          this.pagination.total = data.count;
          this.items = data.data;
          // 加载产品信息以建立产品ID和名称的映射
          this.loadGoodsMap();
        })
        .finally(() => {
          this.loading = false;
        });
    },
    loadGoodsMap() {
      // 从产品信息模块加载所有产品数据，建立product_id -> name的映射
      goodsInformationList({ page: 1, page_size: 1000 }).then((res) => {
        const goodsArray = res.results || [];
        this.goodsMap = {};
        this.goodsInfoMap = {};
        goodsArray.forEach((item) => {
          this.goodsMap[item.id] = item.name;
          this.goodsInfoMap[item.id] = item;
        });
      }).catch(() => {
        // 加载失败不影响表格显示
      });
    },
    create() {
      this.list();
    },
    update() {
      this.list();
    },
    search() {
      this.pagination.current = 1;
      this.searchForm.page = 1;
      this.list();
    },
    openFormModal(item, isRawMaterial = false) {
      this.targetItem = JSON.parse(JSON.stringify(item))
      // 使用缓存中的产品名称，确保显示最新的产品名称
      const productName = this.goodsMap[item.product_id] || item.product_name;
      if (productName) {
        this.targetItem.name = productName + '-' + item.product_id
      }
      this.isRawMaterial = isRawMaterial;
      this.visible = true;
    },
    openFormModal1(item) {
      this.targetItem1 = { ...item }
      const productName = this.goodsMap[item.product_id] || item.product_name;
      this.targetItem1.name = productName + '-' + item.product_id
      this.visible1 = true;
    },
    destroy(id) {
      fromProductDel({ id: id })
        .then((data) => {
          this.$message.success("删除成功");
          this.list();
        })
        .finally(() => {
          this.loading = false;
        });
    },
    tableChange(pagination) {
      this.searchForm.page = pagination.current;
      this.searchForm.page_size = pagination.pageSize
      this.pagination.current = pagination.current;
      this.list();
    }
  },
  mounted() {
    this.initialize();
  },
};
</script>
<style scoped>
::v-deep .ant-table-tbody>tr>td {
  overflow: hidden;
  white-space: nowrap;
}
</style>